import React, { useContext, useEffect, useMemo, useState } from "react";
import { Box, IconButton } from "@mui/material";
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DataTable from "../../components/common/DataTable";
import CustomModal from "../../components/common/CustomModal";
import { genericPost } from '../../services/authServices';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CustomLoader from "../../components/common/CustomLoader";
import MessageBox from "../../components/common/CustomMessageBox";
import { AuthContext } from "../../context/AuthContext";
import CustomDelete from '../../components/common/CustomDeleteAlert'
import CustomMaster from '../../components/common/CustomMaster'
import axios from "axios";
import { NEWS_DELETE, NEWS_GET } from "../../services/apiRoutes";
import { getBlogCategoryList, getBlogStatusList } from "../../services/CommonServices";
import CreateNewsPost from "../components/CreateForm/CreateNewsPost";
import UpdateNewsPost from "../components/UpdateForm/UpdateNewsPost";


const title = "News updates";

const Newsupdates = () => {
    const { token } = useContext(AuthContext)
    const [modal, setModal] = useState(false);
    const [newsList, setNewsList] = useState([]);
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null);
    const [updateModal, setUpdateModal] = useState(false);
    const [blogCategory, setBlogCategory] = useState([]);
    const [blogStatus, setBlogStatus] = useState([]);
    const [selectedId, setSelectedId] = useState(null);
    const currentDate = new Date();
    const sevenDaysAgo = new Date(currentDate);
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 5);
    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    })
    const [deleteAlert, setDeleteAlert] = useState(false)
    const [rowId, setRowId] = useState('')

    const handleOpenDeleteAlert = (rowId) => {
        setDeleteAlert(true)
        setRowId(rowId)
    }
    const handleCloseUpdate = () => {
        setUpdateModal(false);
    };

    const handleUpdateClick = (newsId) => {
        setSelectedId(newsId);
        setUpdateModal(true);
    };

    const columns = useMemo(
        () => [
            {
                accessorKey: "index",
                header: "SN.",
                size: 50,
                tableStyle: { textAlign: "center" },
                enableColumnFilter: false,
            },
            {
                accessorKey: "title",
                header: "Title",
                tableHeader: { justifyContent: "flex-start" },
                size: 200,
            },
            {
                accessorKey: "category",
                header: "Category",
                tableStyle: { textAlign: "center" },
                size: 100,
            },
            {
                accessorKey: "authorName",
                header: "Author",
                tableHeader: { justifyContent: "flex-start" },
                size: 150,
            },
            {
                accessorKey: "views",
                header: "Views",
                tableStyle: { textAlign: "center" },
                size: 80,
            },
            {
                accessorKey: "status",
                header: "Status",
                tableStyle: { textAlign: "center" },
                size: 100,
                Cell: ({ cell }) => (
                    <span
                        style={{
                            color:
                                cell.getValue() === "Published"
                                    ? "green"
                                    : "orange",
                            fontWeight: "bold",
                        }}
                    >
                        {cell.getValue()}
                    </span>
                ),
            },
            {
                accessorKey: "publishedAt",
                header: "Published Date",
                tableStyle: { textAlign: "center" },
                size: 150,
                Cell: ({ cell }) =>
                    cell.getValue()
                        ? new Date(cell.getValue()).toLocaleDateString()
                        : "",
            },
            {
                accessorKey: "createdAt",
                header: "Created At",
                tableStyle: { textAlign: "center" },
                size: 150,
                Cell: ({ cell }) =>
                    cell.getValue()
                        ? new Date(cell.getValue()).toLocaleDateString()
                        : "",
            },
            {
                accessorKey: "action",
                header: "Action",
                size: 100,
                Cell: ({ row }) => (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "4px",
                        }}
                    >
                        <IconButton
                            onClick={() => handleUpdateClick(row.original.newsId)}
                        >
                            <ModeEditOutlineOutlinedIcon
                                style={{ color: "#050C9C" }}
                            />
                        </IconButton>

                        <IconButton
                            onClick={() =>
                                handleOpenDeleteAlert(row.original.newsId)
                            }
                        >
                            <DeleteOutlineOutlinedIcon
                                style={{ color: "#E4003A" }}
                            />
                        </IconButton>
                    </div>
                ),
            },
        ],
        []
    );

    const getNewsList = async () => {
        setLoading(true);
        try {
            const response = await genericPost(NEWS_GET, {});

            if (response.data.success && response.data.news) {
                const newsData = response.data.news.map((news, index) => ({
                    newsId: news.newsId || '',
                    index: (index + 1).toString().padStart(2, '0'),

                    userId: news.userId || '',
                    companyId: news.companyId || '',

                    title: news.title || '',
                    content: news.content || '',
                    featuredImage: news.featuredImage || '',
                    category: news.categoryList?.categoryName || '',
                    status: news.statusList?.statusName || '',

                    metaTitle: news.metaTitle || '',
                    metaDescription: news.metaDescription || '',

                    views: news.views || 0,

                    publishedAt: news.publishedAt || '',
                    createdAt: news.createdAt || '',
                    updatedAt: news.updatedAt || '',

                    authorName: news.user
                        ? `${news.user.firstName || ''} ${news.user.lastName || ''}`
                        : '',
                }));

                setNewsList(newsData);
            } else {
                setError('No news found');
            }
        } catch (error) {
            setError('Error fetching news');
            console.error('Error fetching news', error);
        } finally {
            setLoading(false);
        }
    };
    const handleDelete = async (newsId) => {
        setLoading(true);
        const authToken = sessionStorage.getItem('accessToken');

        try {
            const response = await axios.delete(NEWS_DELETE(newsId), {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.status === 200) {
                setMessage({
                    open: true,
                    text: "news deleted successfully",
                    type: "success",
                });

                getNewsList();
                setDeleteAlert(false);
            }
        } catch (error) {
            setLoading(false);
            setMessage({
                open: true,
                text: "Error deleting news",
                type: "error",
            });
        }
    };
    useEffect(() => {
        getNewsList()
    }, [token])

    const handleOpen = () => {
        setModal(true);
    };
    const handleClose = () => {
        setModal(false)
    }


    useEffect(() => {
        getCommonData()
    }, [])

    const getCommonData = async () => {
        const blogCategoryList = await getBlogCategoryList()
        setBlogCategory(blogCategoryList);
        const blogStatusList = await getBlogStatusList()
        setBlogStatus(blogStatusList);
    }

    const defaultView = 'newsupdates';
    const mainContent = (
        <>
            <Box sx={{ padding: "10px" }}>
                <CustomLoader open={loading} />
                <DataTable
                    title={title}
                    columns={columns}
                    data={newsList}
                    handleOpen={handleOpen}
                    buttonTitle="Add News Update"
                />
                <CustomModal

                    open={modal} handleClose={handleClose}>
                    <CreateNewsPost
                        handleClose={handleClose}
                        fetchData={getNewsList}
                        setMessage={setMessage}
                        blogCategory={blogCategory}
                        blogStatus={blogStatus}
                    />
                </CustomModal>
                <CustomModal

                    open={updateModal} handleClose={handleCloseUpdate}>
                    <UpdateNewsPost
                        handleClose={handleCloseUpdate}
                        newsId={selectedId}
                        getNewsList={getNewsList}
                        setMessage={setMessage}
                        blogCategory={blogCategory}
                        blogStatus={blogStatus}
                    />
                </CustomModal>
                <MessageBox
                    open={message.open}
                    onClose={() => setMessage({ ...message, open: false })}
                    message={message.text}
                    handleClose={() => setMessage({ ...message, open: false })}
                    type={message.type}
                />

            </Box>
            <CustomDelete
                handleDelete={handleDelete}
                open={deleteAlert}
                rowId={rowId}
                handleClose={() => setDeleteAlert(false)}
            />
        </>
    );

    return (
        <CustomMaster
            defaultView={defaultView}
            mainContent={mainContent} />
    );
};
export default Newsupdates;

